import { TranslationService } from '../../../../../services/translation.service';
import { AnalyticsService } from '../../../../../services/analytics-service';
import { SanitizerService } from '../../../../../services/sanitizer.service';
import commuterParkingLotFilterIcon from '../../../../../../assets/icons/commute-parking-lot-filter.svg';
import ticketOfficeFilterIcon from '../../../../../../assets/icons/ticket-office-filter-blue-1000.svg';
import stopAreaFilterIcon from '../../../../../../assets/icons/stop-area-filter.svg';
import CheckboxFilter from './components/CheckboxFilter';
import DataUrlHelper from '../../../../../helpers/data-url.helper';

export interface IMapFiltersSelection {
  showStopAreas: boolean;
  showCommuterParkingLots: boolean;
  showTicketOffices: boolean;
}

function MapFilters({ className = '', selection, onChange }: { className?: string; selection: IMapFiltersSelection; onChange: (selection: IMapFiltersSelection) => void }) {
  return (
    <div className={`map-filters-component ${className}`}>
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: SanitizerService.sanitizeHtml(TranslationService.get('stopareasearchpage.mapfilterselectionheadingtext')),
          }}
        ></div>
      </div>
      <fieldset>
        <legend className="visually-hidden">{TranslationService.get('stopareasearchpage.selectfilterstoshow')}</legend>

        <CheckboxFilter
          id="stopAreasSelect"
          text={TranslationService.get('stopareasearchpage.stopareas')}
          checked={selection.showStopAreas}
          className="mb-2"
          onChange={(checked) => {
            AnalyticsService.addEvent(AnalyticsService.StopArea, 'Filter: Hållplatser', checked ? 'Ja' : 'Nej');
            onChange({ ...selection, showStopAreas: checked });
          }}
          iconSrc={DataUrlHelper.encode(stopAreaFilterIcon)}
        />

        <CheckboxFilter
          id="commuterParkingLotSelect"
          text={TranslationService.get('stopareasearchpage.parkingspaces')}
          checked={selection.showCommuterParkingLots}
          className="mb-2"
          onChange={(checked) => {
            AnalyticsService.addEvent(AnalyticsService.StopArea, 'Filter: Pendlarparkering', checked ? 'Ja' : 'Nej');
            onChange({ ...selection, showCommuterParkingLots: checked });
          }}
          iconSrc={DataUrlHelper.encode(commuterParkingLotFilterIcon)}
        />

        <CheckboxFilter
          id="ticketOfficeSelect"
          text={TranslationService.get('stopareasearchpage.ticketoffices')}
          checked={selection.showTicketOffices}
          onChange={(checked) => {
            AnalyticsService.addEvent(AnalyticsService.StopArea, 'Filter: Ombud', checked ? 'Ja' : 'Nej');
            onChange({ ...selection, showTicketOffices: checked });
          }}
          iconSrc={DataUrlHelper.encode(ticketOfficeFilterIcon)}
        />
      </fieldset>
    </div>
  );
}

export default MapFilters;
